var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import { Show, SimpleShowLayout, useCheckMinimumRequiredProps, } from 'react-admin';
import FieldGuesser from './FieldGuesser';
import Introspecter from './Introspecter';
import useMercureSubscription from './useMercureSubscription';
const displayOverrideCode = (schema, fields) => {
    if (process.env.NODE_ENV === 'production')
        return;
    let code = 'If you want to override at least one field, paste this content in the <ShowGuesser> component of your resource:\n\n';
    code += `const ${schema.title}Show = props => (\n`;
    code += `    <ShowGuesser {...props}>\n`;
    fields.forEach((field) => {
        code += `        <FieldGuesser source={"${field.name}"} addLabel={true} />\n`;
    });
    code += `    </ShowGuesser>\n`;
    code += `);\n`;
    code += `\n`;
    code += `And don't forget update your <ResourceGuesser> component:\n`;
    code += `<ResourceGuesser name={"${schema.name}"} show={${schema.title}Show} />`;
    // eslint-disable-next-line no-console
    console.info(code);
};
export const IntrospectedShowGuesser = (_a) => {
    var { fields, readableFields, writableFields, schema, schemaAnalyzer, children } = _a, props = __rest(_a, ["fields", "readableFields", "writableFields", "schema", "schemaAnalyzer", "children"]);
    let fieldChildren = children;
    if (!fieldChildren) {
        fieldChildren = readableFields.map((field) => (React.createElement(FieldGuesser, { key: field.name, source: field.name, addLabel: true })));
        displayOverrideCode(schema, readableFields);
    }
    useMercureSubscription(props.resource, props.id);
    return (React.createElement(Show, Object.assign({}, props),
        React.createElement(SimpleShowLayout, null, fieldChildren)));
};
const ShowGuesser = (props) => {
    useCheckMinimumRequiredProps('ShowGuesser', ['resource'], props);
    const { resource } = props, rest = __rest(props, ["resource"]);
    if (!resource) {
        return null;
    }
    return (React.createElement(Introspecter, Object.assign({ component: IntrospectedShowGuesser, resource: resource }, rest)));
};
/* eslint-disable tree-shaking/no-side-effects-in-initialization */
ShowGuesser.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    resource: PropTypes.string.isRequired,
};
/* eslint-enable tree-shaking/no-side-effects-in-initialization */
export default ShowGuesser;
//# sourceMappingURL=ShowGuesser.js.map